<template>
  <div class="pal clearfix">
    <ui-navigation></ui-navigation>
    <ui-center :token="token"></ui-center>
  </div>
</template>

<script>
import Navigation from '@/components/layout/Navigation.vue';
import Center from '@/components/pay/Center.vue';
export default {
  name: 'pal',
  props:['token'],
  components:{
    'ui-navigation': Navigation,
    'ui-center': Center
  }
}
</script>

<style scoped lang='less'>
.pal{
  min-height: 100vh;
  background: #000000;
}
@media (max-width: 1200px) {
  .pal{
  }
}
@media (max-width: 992px) {
  .pal{
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pay/Pay.vue